var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 367.01 361.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.33px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n        opacity: .19;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 72.1,
    y1: 374.05,
    x2: 295.66,
    y2: -13.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 72.46,
    y1: 373.43,
    x2: 295.31,
    y2: -12.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 66.02,
    y1: 384.57,
    x2: 301.74,
    y2: -23.69,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "index"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.38,349.72H31.38c-7.54-7.54-11.77-11.77-19.31-19.31V30.47c7.54-7.54,11.77-11.77,19.31-19.31h305.01c7.54,7.54,11.77,11.77,19.31,19.31v299.93c-7.54,7.54-11.77,11.77-19.31,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.38,349.72H31.38c-7.54-7.54-11.77-11.77-19.31-19.31V30.47c7.54-7.54,11.77-11.77,19.31-19.31h305.01c7.54,7.54,11.77,11.77,19.31,19.31v299.93c-7.54,7.54-11.77,11.77-19.31,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.55,360.88H24.98L.75,336.64v-155.1l2,2.83v151.44l23.06,23.06h100.33l1.41,2ZM176.13,0H24.98L.75,24.23v60.43l2,2V25.06L25.81,2h148.32l2-2ZM223.63,0h-25l-2,2h25l2-2ZM268.88,0h-22.75l-2,2h22.75l2-2ZM342.78,0h-51.39l-2,2h52.57l23.06,23.06v310.75l-23.06,23.06h-66.98l2,2h65.81l24.23-24.23V24.23L342.78,0ZM2.12,164.07c-1.17,0-2.12.95-2.12,2.12s.95,2.12,2.12,2.12,2.12-.95,2.12-2.12-.95-2.12-2.12-2.12ZM2.12,150.32c-1.17,0-2.12.95-2.12,2.12s.95,2.12,2.12,2.12,2.12-.95,2.12-2.12-.95-2.12-2.12-2.12ZM2.12,139.57c-1.17,0-2.12.95-2.12,2.12s.95,2.12,2.12,2.12,2.12-.95,2.12-2.12-.95-2.12-2.12-2.12ZM233.69,359.82c0-1.17-.95-2.12-2.12-2.12s-2.12.95-2.12,2.12.95,2.12,2.12,2.12,2.12-.95,2.12-2.12ZM247.44,359.82c0-1.17-.95-2.12-2.12-2.12s-2.12.95-2.12,2.12.95,2.12,2.12,2.12,2.12-.95,2.12-2.12ZM258.19,359.82c0-1.17-.95-2.12-2.12-2.12s-2.12.95-2.12,2.12.95,2.12,2.12,2.12,2.12-.95,2.12-2.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMao);
export default __webpack_public_path__ + "static/media/mao.450ee6c8203fa9dcbb7d3a0e3f2ec1fa.svg";
export { ForwardRef as ReactComponent };